import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type ClosestCityResult = {
  id: string;
  name: string;
  emoji: string;
};

export type LocationResult = {
  placeId: string;
  name: string;
  address: string;
  lat: number | null;
  lng: number | null;
  primaryType: string | null;
};

export function useLocationSearch() {
  return useMutation({
    mutationFn: async (query: string) =>
      api.post<LocationResult[]>(`/host/locations/search`, { query }),
  });
}

// Resolve the closest Outclose city for a coordinate. Used by the host
// event create form to auto-populate the city when a venue is picked.
export function useClosestCity() {
  return useMutation({
    mutationFn: async ({ lat, lng }: { lat: number; lng: number }) =>
      api.get<ClosestCityResult>(
        `/host/locations/closest-city?lat=${lat}&lng=${lng}`,
      ),
  });
}
